import { useCallback, useState } from "react";

// Keep drafts in the mounted surface, never in storage containing private text.
const useReviewDrafts = () => {
  const [drafts, setDrafts] = useState({});
  const updateDraft = useCallback((sessionId, draft) => {
    setDrafts((items) => ({ ...items, [sessionId]: draft }));
  }, []);
  const clearDraft = useCallback((sessionId) => {
    setDrafts((items) => {
      const next = { ...items };
      delete next[sessionId];
      return next;
    });
  }, []);
  return { drafts, updateDraft, clearDraft };
};

export default useReviewDrafts;
